import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { VoiceBotService } from '../services/voice-bot.service';
import '../common/agent-element';
import { BehaviorSubject } from 'rxjs';
import { MicrophoneService } from '../services/microphone.service';

@Component({
  selector: 'app-hal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div>
      <div id="agent-box"></div>
    </div>
  `,
  styleUrls: ['./hal.component.scss']
})
export class HalComponent implements AfterViewInit, OnChanges, OnInit {
  private agent!: HTMLElement;
  @Input() cif: string | null = null;
  @Input() currentSessionId: string | null = null;

  constructor(private voiceBotService: VoiceBotService,
    private microphoneService: MicrophoneService) {}

  ngOnInit(): void {
    //this.agent = document.createElement('deepgram-agent');
    this.agent = document.createElement('deepgram-agent') as any;
    (this.agent as any).microphoneService = this.microphoneService;
    const agentBox = document.getElementById('agent-box');

    this.agent.setAttribute("cif", this.cif);
    this.agent.setAttribute("currentSessionId", this.currentSessionId);

    if (agentBox) {
      agentBox.appendChild(this.agent);
    }

    this.connectAgent();
  }

  ngAfterViewInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
   
  }

  ngOnDestroy() {
   this.disconnectAgent();
  }

  async connectAgent(): Promise<void> {
    try {
      await (this.agent as any).connect();
      console.log('Agent connected');
    } catch (error) {
      console.error('Failed to connect:', error);
    }
  }

  async disconnectAgent(): Promise<void> {
    try {
      await (this.agent as any).disconnect();
      console.log('Agent disconnected');
    } catch (error) {
      console.error('Failed to disconnect:', error);
    }
  }
}
